<template>
  <section class="section-monsters" id="#section-monsters">
    <div class="section-monsters--sticky">
      <img
        class="sticky-image"
        src="https://ik.imagekit.io/intervi/1-inne_guvjhO_jw.png"
        data-src="https://ik.imagekit.io/intervi/1-inne_guvjhO_jw.png"
        alt="Grafika z laptopem"
        data-aos="fade-up"
      />
      <img
        class="sticky-image sticky-image2"
        src="https://ik.imagekit.io/intervi/1-inne2_8AfSFjl9w.png"
        data-src="https://ik.imagekit.io/intervi/1-inne2_8AfSFjl9w.png"
        alt="Grafika z laptopem"
        data-aos="fade-up"
      />
      <div class="sticky-text">
        honorable mention
        <span>on Behance</span>
      </div>
    </div>
    <div class="section-monsters__boxes position-relative">
      <img
        id="lights"
        src="https://ik.imagekit.io/intervi/social_monster_new/swiatla_nHg1AOo5Q.png"
        data-src="https://ik.imagekit.io/intervi/social_monster_new/swiatla_nHg1AOo5Q.png"
        alt="Swiatla drogowe"
      />
      <img
        id="monsters"
        src="https://ik.imagekit.io/intervi/social_monster_new/social-mmonster-top1_XL9TWBuY-.png"
        data-src="https://ik.imagekit.io/intervi/social_monster_new/social-mmonster-top1_XL9TWBuY-.png"
        alt="Monstery na rowerze"
      />
      <img
        id="hydrant"
        src="https://ik.imagekit.io/intervi/social_monster_new/Hydrant_oLlyp_tor.png"
        data-src="https://ik.imagekit.io/intervi/social_monster_new/Hydrant_oLlyp_tor.png"
        alt="Hydrant"
      />
    </div>
  </section>
</template>

<script>
export default {
  mounted: function() {
    this.moveLights();
    this.moveMonsters();
    this.moveHydrant();
  },
  methods: {
    moveLights: function() {
      $(document).mousemove(function(event) {
        $("#lights").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 20,
            ease: Power1.easeOut
          });
        });
      });
    },
    moveMonsters: function() {
      $(document).mousemove(function(event) {
        $("#monsters").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -20,
            ease: Power1.easeOut
          });
        });
      });
    },
    moveHydrant: function() {
      $(document).mousemove(function(event) {
        $("#hydrant").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 10,
            ease: Power1.easeOut
          });
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.section-monsters {
  background: #46d0ff;
  &--sticky {
    position: absolute;
    top: 0;
    left: 30%;
    display: flex;
    align-items: flex-start;
    @media (max-width: 1680px) {
      left: 25%;
    }
    @media (max-width: 1440px) {
      left: 22%;
    }
    @media (max-width: 1366px) {
      left: 20%;
    }
    @media (max-width: 1200px) {
      left: unset;
      right: 200px;
    }
    // Sticky elemets
    .sticky-image {
      width: 40px;
      height: auto;
    }
    .sticky-image2 {
      margin-left: 10px;
    }
    .sticky-text {
      text-align: right;
      color: #fff;
      font-weight: 800;
      font-size: 1.4rem;
      margin-top: 33px;
      margin-left: 20px;
    }
    .sticky-image,
    .sticky-text,
    .sticky-text2 {
      @media (max-width: 768px) {
        display: none;
      }
    }
  }

  &__boxes {
    width: 60%;
    height: 100%;
    margin-left: 40%;
    @media (max-width: 768px) {
      width: 100%;
      height: 70%;
      margin-top: 30%;
      margin-left: 0;
    }

    #lights {
      max-width: 150px;
      width: 100%;
      position: absolute;
      top: 30%;
      left: 0;
      @media (max-width: 1200px) {
        max-width: 120px;
      }
      @media (max-width: 768px) {
        display: none;
      }
    }

    #monsters {
      max-width: 650px;
      width: 100%;
      position: absolute;
      top: 20%;
      left: 10%;
      @media (max-width: 1640px) {
        max-width: 550px;
        left: 15%;
      }
      @media (max-width: 1200px) {
        max-width: 450px;
      }
      @media (max-width: 768px) {
        bottom: 13%;
        top: auto;
        left: 0;
        height: auto;
        width: 100%;
      }
      @media (max-width: 640px) {
        bottom: 7%;
      }
    }
    #hydrant {
      max-width: 200px;
      width: 100%;
      position: absolute;
      top: 60%;
      left: 60%;
      @media (max-width: 1640px) {
        max-width: 150px;
        left: 70%;
        top: 70%;
      }
      @media (max-width: 1200px) {
        top: 60%;
      }
      @media (max-width: 992px) {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentSocialMonsterNew.vue